import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "OOSREL",
  title: defineMessage({
    id: "fig.access.OOSREL.title",
    defaultMessage: `School-age population, out-of-school rate and out-of-school number, 1990-2020`,
  }),
  caption: defineMessage({
    id: "fig.access.OOSREL.caption",
    defaultMessage: `The number of out-of-school children in sub-Saharan Africa has barely fallen since 1990`,
  }),
  source: defineMessage({
    id: "fig.access.OOSREL.source",
    defaultMessage: `GEM Report team analysis based on UIS data`,
  }),
};
